import { DataType } from '@miq/catalog';

export const floorSpaceDetailsTableColumns = [
  Object.freeze({
    header: 'Tenant',
    columnId: 90001,
    field: 'tenant',
    path: 'tenant',
    sortable: true,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'Property Type',
    columnId: 90002,
    field: 'propertyType',
    path: 'propertyType',
    sortable: true,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'SF',
    columnId: 90003,
    field: 'sf',
    path: 'sf',
    sortable: true,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'Lease Type',
    columnId: 90005,
    field: 'leaseType',
    path: 'leaseType',
    sortable: true,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'End Date',
    columnId: 90004,
    field: 'endDate',
    path: 'endDate',
    sortable: true,
    dataType: DataType.String,
  }),
];
